<script>
import GameMapWorld from "@/components/hub-map-preview/GameMapWorld.vue";
import MapActionPanel from "@/components/hub-map-preview/MapActionPanel.vue";
import "@/assets/fonts/font-awesome-4.7.0/css/font-awesome.min.css";

export default {
  name: "Hub3DPreview",
  components: {
    GameMapWorld,
    MapActionPanel
  },
  data() {
    return {
      locations: [
        {
          id: "deposit",
          label: "แจ้งฝาก",
          caption: "ธนาคารฝากเหรียญ เติมเครดิตได้ตลอด 24 ชั่วโมง",
          route: "/deposit",
          accent: "#4de0ad",
          glow: "rgba(77, 224, 173, 0.35)",
          symbol: "↓",
          icon: "fa fa-download",
          iconGlyph: "\uf019",
          menuHint: "เหรียญไหลเข้า · ฝากเครดิต",
          zone: "01",
          mapU: 0.365,
          mapV: 0.3,
          markerOffsetX: 42,
          markerOffsetY: -76
        },
        {
          id: "withdraw",
          label: "แจ้งถอน",
          caption: "ตู้เซฟถอนเหรียญ รับเครดิตออกอย่างปลอดภัย",
          route: "/withdraw",
          accent: "#63b9f5",
          glow: "rgba(99, 185, 245, 0.35)",
          symbol: "↑",
          icon: "fa fa-upload",
          iconGlyph: "\uf093",
          menuHint: "เหรียญไหลออก · ถอนเครดิต",
          zone: "02",
          mapU: 0.64,
          mapV: 0.3,
          markerOffsetX: -42,
          markerOffsetY: -76
        },
        {
          id: "spin",
          label: "Spin",
          caption: "วงล้อ Spin ของรางวัล หมุนเพื่อลุ้นโบนัสพิเศษ",
          route: "/spin-preview",
          accent: "#ff5f91",
          glow: "rgba(255, 95, 145, 0.38)",
          symbol: "✦",
          icon: "fa fa-circle-o-notch",
          iconGlyph: "\uf1ce",
          menuHint: "วงล้อตั้ง · หมุนลุ้นโบนัส",
          zone: "03",
          mapU: 0.307,
          mapV: 0.462,
          markerOffsetX: 46,
          markerOffsetY: -78
        },
        {
          id: "roulette",
          label: "Roulette",
          caption: "คาสิโนโต๊ะ Roulette เลือกเลข สี และชิปเดิมพัน",
          route: "/roulet-preview",
          accent: "#ff765d",
          glow: "rgba(255, 118, 93, 0.4)",
          symbol: "●",
          icon: "fa fa-dot-circle-o",
          iconGlyph: "\uf192",
          menuHint: "โต๊ะนอน · เล่นเลขและสี",
          zone: "04",
          mapU: 0.719,
          mapV: 0.447,
          markerOffsetX: -46,
          markerOffsetY: -78
        },
        {
          id: "reward",
          label: "แลกของรางวัล",
          caption: "ร้านกล่องของขวัญ ใช้แต้มแลกรางวัลพิเศษ",
          route: "/reward",
          accent: "#f3c453",
          glow: "rgba(243, 196, 83, 0.38)",
          symbol: "★",
          icon: "fa fa-gift",
          iconGlyph: "\uf06b",
          menuHint: "กล่องของขวัญ · ใช้แต้มแลก",
          zone: "05",
          mapU: 0.374,
          mapV: 0.665,
          markerOffsetX: 46,
          markerOffsetY: -74
        },
        {
          id: "friend",
          label: "แนะนำเพื่อน",
          caption: "กิลด์จับมือ ชวนเพื่อนมารับโบนัสด้วยกัน",
          route: "/sharefriend",
          accent: "#b990f2",
          glow: "rgba(185, 144, 242, 0.38)",
          symbol: "+",
          icon: "fa fa-users",
          iconGlyph: "\uf0c0",
          menuHint: "จับมือ · ชวนเพื่อนรับโบนัส",
          zone: "06",
          mapU: 0.67,
          mapV: 0.665,
          markerOffsetX: -46,
          markerOffsetY: 24
        },
        {
          id: "play",
          label: "เข้าเล่น",
          caption: "ประตูจอยเกม เข้าสู่เกมทั้งหมดได้ทันที",
          route: "/login",
          accent: "#ff9b54",
          glow: "rgba(255, 155, 84, 0.4)",
          symbol: "▶",
          icon: "fa fa-play",
          iconGlyph: "\uf04b",
          menuHint: "จอยเกม · เข้าเล่นทั้งหมด",
          zone: "07",
          mapU: 0.5,
          mapV: 0.505,
          markerOffsetX: 138,
          markerOffsetY: 82
        }
      ],
      activeId: "play",
      isMoving: false,
      nightMode: true,
      soundEnabled: true,
      audioContext: null
    };
  },
  computed: {
    activeAction() {
      return (
        this.locations.find(location => location.id === this.activeId) ||
        this.locations[0]
      );
    }
  },
  methods: {
    selectLocation(id) {
      const location = this.locations.find(item => item.id === id);
      if (!location) return;

      this.activeId = id;
      if (this.soundEnabled) this.playSelectTone();
      if (navigator.vibrate) navigator.vibrate(14);
    },
    handleMovement(moving) {
      this.isMoving = moving;
    },
    openActiveLocation() {
      this.$router.push(this.activeAction.route);
    },
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
    },
    toggleNightMode() {
      this.nightMode = !this.nightMode;
      if (navigator.vibrate) navigator.vibrate(10);
    },
    playSelectTone() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;

        if (!this.audioContext) {
          this.audioContext = new AudioContext();
        }

        const context = this.audioContext;
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        const now = context.currentTime;

        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(430, now);
        oscillator.frequency.exponentialRampToValueAtTime(680, now + 0.1);
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.065, now + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.13);
        oscillator.connect(gain);
        gain.connect(context.destination);
        oscillator.start(now);
        oscillator.stop(now + 0.14);
      } catch (error) {
        // Sound is optional; visual and haptic feedback remain available.
      }
    }
  }
};
</script>

<template>
  <div class="map-hub" :class="{ 'map-hub--night': nightMode }">
    <GameMapWorld
      :locations="locations"
      :active-id="activeId"
      :night-mode="nightMode"
      @select="selectLocation"
      @movement="handleMovement"
    />

    <header class="map-header">
      <div class="map-header__brand">
        <div class="map-header__logo-shell">
          <img
            class="map-header__logo"
            src="../assets/images/logo2.png"
            alt="UFA Easy888"
          />
        </div>
        <div class="map-header__copy">
          <strong>UFA KINGDOM</strong>
          <small><i aria-hidden="true"></i> ONLINE WORLD</small>
        </div>
      </div>

      <div class="map-header__controls">
        <button
          class="map-header__mode"
          :class="{ 'map-header__mode--night': nightMode }"
          type="button"
          :aria-label="
            nightMode ? 'เปลี่ยนเป็นโหมดกลางวัน' : 'เปลี่ยนเป็นโหมดกลางคืน'
          "
          :aria-pressed="nightMode ? 'true' : 'false'"
          @click="toggleNightMode"
        >
          <i
            class="fa"
            :class="nightMode ? 'fa-sun-o' : 'fa-moon-o'"
            aria-hidden="true"
          ></i>
        </button>

        <button
          class="map-header__sound"
          type="button"
          :aria-label="soundEnabled ? 'ปิดเสียง' : 'เปิดเสียง'"
          :aria-pressed="soundEnabled ? 'true' : 'false'"
          @click="toggleSound"
        >
          <svg
            v-if="soundEnabled"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5 9v6h4l5 4V5L9 9H5Z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linejoin="round"
            />
            <path
              d="M17 9c1.4 1.8 1.4 4.2 0 6"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M5 9v6h4l5 4V5L9 9H5Z"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linejoin="round"
            />
            <path
              d="m17 10 4 4m0-4-4 4"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </header>

    <div class="map-mission">
      <i
        class="fa"
        :class="nightMode ? 'fa-moon-o' : 'fa-arrows'"
        aria-hidden="true"
      ></i>
      <strong>
        {{
          nightMode
            ? "NIGHT MODE · ลาก · จีบเพื่อซูม"
            : "ลากสำรวจ · จีบเพื่อซูม"
        }}
      </strong>
    </div>

    <div class="map-compass" aria-hidden="true">
      <span>N</span>
      <i></i>
    </div>

    <MapActionPanel
      :action="activeAction"
      :locations="locations"
      :active-id="activeId"
      :moving="isMoving"
      @select="selectLocation"
      @open="openActiveLocation"
    />
  </div>
</template>

<style scoped>
@font-face {
  font-family: "Sukhumvit Set";
  src: url("../assets/fonts/SukhumvitSet-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Sukhumvit Set";
  src: url("../assets/fonts/SukhumvitSet-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/poppins/Poppins-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/poppins/Poppins-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

.map-hub {
  position: fixed;
  inset: 0;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  color: #f8fbff;
  background: #2f75a5;
  font-family: "Sukhumvit Set", sans-serif;
}

.map-hub::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 20;
  pointer-events: none;
  opacity: 0.14;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.18'/%3E%3C/svg%3E");
  mix-blend-mode: soft-light;
}

.map-header {
  position: absolute;
  top: max(12px, env(safe-area-inset-top));
  right: 15px;
  left: 15px;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 720px;
  margin: 0 auto;
  pointer-events: none;
}

.map-header__brand {
  display: flex;
  align-items: center;
  padding: 6px 11px 6px 7px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 17px;
  background: rgba(15, 45, 67, 0.62);
  box-shadow: 0 8px 24px rgba(12, 40, 62, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  gap: 8px;
}

.map-header__logo-shell {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 226, 143, 0.5);
  border-radius: 12px;
  background: linear-gradient(145deg, #835f2d, #2a2c33);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.map-header__logo {
  width: 27px;
  height: 27px;
  object-fit: contain;
}

.map-header__copy {
  display: flex;
  flex-direction: column;
  font-family: "Poppins", sans-serif;
}

.map-header__copy strong {
  color: #fff1ba;
  font-size: 10px;
  letter-spacing: 0.1em;
  line-height: 1.3;
}

.map-header__copy small {
  display: flex;
  align-items: center;
  color: rgba(236, 247, 255, 0.59);
  font-size: 6px;
  font-weight: 500;
  letter-spacing: 0.14em;
}

.map-header__copy i {
  width: 4px;
  height: 4px;
  margin-right: 4px;
  border-radius: 50%;
  background: #65e8ac;
  box-shadow: 0 0 6px #65e8ac;
}

.map-header__controls {
  display: flex;
  align-items: center;
  pointer-events: none;
  gap: 8px;
}

.map-header__mode,
.map-header__sound {
  appearance: none;
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  padding: 0;
  color: #f4faff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  background: rgba(15, 45, 67, 0.62);
  box-shadow: 0 8px 24px rgba(12, 40, 62, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  cursor: pointer;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
}

.map-header__mode {
  color: #dce9ff;
  font-size: 18px;
  transition: color 280ms ease, border-color 280ms ease, background 280ms ease,
    box-shadow 280ms ease;
}

.map-header__mode--night {
  color: #ffe28a;
  border-color: rgba(173, 195, 255, 0.55);
  background: rgba(12, 24, 64, 0.78);
  box-shadow: 0 8px 24px rgba(6, 11, 38, 0.38),
    0 0 18px rgba(117, 151, 255, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.map-header__sound svg {
  width: 20px;
  height: 20px;
}

.map-header__mode:focus-visible,
.map-header__sound:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 3px;
}

.map-mission {
  position: absolute;
  top: max(73px, calc(env(safe-area-inset-top) + 65px));
  left: 50%;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 32px;
  padding: 5px 12px;
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 99px;
  background: rgba(6, 33, 48, 0.68);
  box-shadow: 0 8px 22px rgba(4, 24, 38, 0.26),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transform: translateX(-50%);
  gap: 7px;
}

.map-mission i {
  color: #ffe29a;
  font-size: 11px;
}

.map-mission strong {
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
}

.map-compass {
  position: absolute;
  top: 137px;
  right: 17px;
  z-index: 4;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: rgba(255, 255, 255, 0.8);
  filter: drop-shadow(0 2px 3px rgba(20, 47, 69, 0.35));
  font-family: "Poppins", sans-serif;
  font-size: 7px;
  font-weight: 700;
}

.map-compass i {
  width: 0;
  height: 0;
  margin-top: 2px;
  border-right: 5px solid transparent;
  border-bottom: 17px solid rgba(255, 255, 255, 0.72);
  border-left: 5px solid transparent;
  transform: rotate(16deg);
}
</style>
